import React from "react";
import { Chip, ChipProps } from "@cmp-src/data-display/chips/Chip/Chip";
import { IUserFull } from "@gettactic/api";
import { getRandomColor } from "@gettactic/helpers/src/colors";
import { getInitials } from "@gettactic/helpers";

export interface UserChipProps extends ChipProps {
  user: Partial<IUserFull>;
  useColoredBorder?: boolean;
}

export const UserChip: React.FC<UserChipProps> = ({
  user,
  useColoredBorder,
  ...props
}) => {
  const fallbackColor = getRandomColor({ string: user.name || "" });
  return (
    <Chip
      pictureUrl={user.profile_photo_url}
      pictureFallback={user.name ? getInitials(user.name) : ""}
      {...props}
      borderColor={useColoredBorder ? fallbackColor : undefined}
      fallbackColor={fallbackColor}
    >
      {user.name}
    </Chip>
  );
};
